export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"}],"link":[{"rel":"preconnect","href":"https://maps.googleapis.com"},{"rel":"preconnect","href":"https://maps.gstatic.com","crossorigin":"anonymous"},{"rel":"preload","as":"style","href":"https://imgqa.ihreapotheken.de/fonts/denwerk_fonts.css"},{"rel":"stylesheet","href":"https://imgqa.ihreapotheken.de/fonts/denwerk_fonts.css"}],"style":[],"script":[],"noscript":[],"htmlAttrs":{"lang":"de"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'